import { defineSSOClient } from '@/plugins/request/index.js';

export const useSSOAuthClient = defineSSOClient({
  options: ({ baseURL }) => ({
    baseURL: `${baseURL}/oauth/v2/auth`,
  }),
});
